import React, { useState, useLayoutEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Container, Box, Grid, TextField, Typography, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { Link as RouterLink, useHistory } from 'react-router-dom'

import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

import { useDispatch, useSelector } from 'react-redux';
import {
    setHeiress,
    clearHeiress,
} from '../stores/heiress'

import MenuList from './MenuList' // メニュー
import GuideHalf from './GuideHalf' // ガイド

import FlowTitle from './FlowTitle' // フロータイトル
import FlowItem from './FlowItem' // フローアイテム
import FlowArrow from './FlowArrow' // フローアロー
import FlowCaution from './FlowCaution' // フロー注意

import PageExplanation from './PageExplanation' // ページ説明

import PageStep from './PageStep' // ステップ
import PersonStep from './PersonStep' // 個人情報ステップ

const useStyles = makeStyles((theme) => ({
    menu: {
        marginTop: '1rem',
    },
    explanation: {
        marginTop: '1rem',
        padding: '.5rem'
    },
    head: {
        backgroundColor: '#3f51b5',
        color: '#fff'
    },
    list: {
        marginTop: '1rem'
    },
    required: {
        '& .MuiFormHelperText-root': {
            color: '#f00'
        }
    },
}));

// 相続人
function Heiress(){
    const dispatch = useDispatch();

    const igonFlag = useSelector(state => state.igon.igonFlag);
    const heiress = useSelector(state => state.heiress.heiress);

    const history = useHistory();

    const [nextFlag, setNextFlag] = useState(true);

    const handleHeiress = (event) => {
        const heiressName = document.getElementById('heiress_name').value;
        const heiressBirthday = document.getElementById('heiress_birthday').value;
        const heiressRelationship = document.getElementById('heiress_relationship').value;

        if(heiressName == ''){
            checkName(true);
            nameHelper('お名前は必ずご入力くさだい。');
        }else if(heiressBirthday == ''){
            checkBirthday(true);
            birthHelper('生年月日は必ずご入力くさだい。');
        }else if(heiressRelationship == ''){
            checkRelationship(true);
            relationshipHelper('続柄は必ずご入力くさだい。');
        }else{
            document.getElementById('heiress_name').value = '';
            document.getElementById('heiress_birthday').value = '';
            document.getElementById('heiress_relationship').value = '';

            setNameValue(null);
            setBirthdayValue(null);
            setRelationshipValue(null);

            const heiress = {
                name: heiressName,
                birthday: heiressBirthday,
                relationship: heiressRelationship
            };

            setNextFlag(false);

            dispatch(setHeiress(heiress));
        }
    }

    const [nameValue, setNameValue] = useState(null);
    const [birthdayValue, setBirthdayValue] = useState(null);
    const [relationshipValue, setRelationshipValue] = useState(null);

    const handleHeiressEdit = (index, event) => {
        const heiressEdit = heiress[index];

        setNameValue(heiressEdit.name);
        setBirthdayValue(heiressEdit.birthday);
        setRelationshipValue(heiressEdit.relationship);

        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });

        dispatch(clearHeiress(index))
    }

    const handleHeiressDelete = (index, event) => {
        dispatch(clearHeiress(index))
        setOpen(false);
    }

    const [nameHelperText, nameHelper] = useState('必須');
    const [birthHelperText, birthHelper] = useState('必須');
    const [relationshipHelperText, relationshipHelper] = useState('必須');

    const [nameValidate, checkName] = useState(false);
    const handleName = (event) => {
        if(event.target.value){
            checkName(false);
            nameHelper('必須');
            setNameValue(event.target.value);
        }else{
            checkName(true);
            nameHelper('お名前は必ずご入力くさだい。');
            setNameValue(null);
        }
    }

    const [birthdayValidate, checkBirthday] = useState(false);
    const handleBirthday = (event) => {
        if(event.target.value){
            checkBirthday(false);
            birthHelper('必須');
            setBirthdayValue(event.target.value);
        }else{
            checkBirthday(true);
            birthHelper('生年月日は必ずご入力くさだい。');
            setBirthdayValue(null);
        }
    }

    const [relationshipValidate, checkRelationship] = useState(false);
    const handleRelationship = (event) => {
        if(event.target.value){
            checkRelationship(false);
            relationshipHelper('必須');
            setRelationshipValue(event.target.value);
        }else{
            checkRelationship(true);
            relationshipHelper('続柄は必ずご入力くさだい。');
            setRelationshipValue(null);
        }
    }

    const [deleteTargetIndex, deleteTarget] = useState(null);

    const [open, setOpen] = useState(false);

    const handleDialogOpen = (index) => {
        setOpen(true);
        deleteTarget(index);
    }

    const handleDialogClose = () => {
        setOpen(false);
    }

    const classes = useStyles();

    useLayoutEffect(() => {
        if(heiress.length){
            setNextFlag(false);
        }
    });

    return(
        <Container>

            <Grid container spacing={3}>
                <Grid item xs={12} lg={6}>
                    <PageExplanation pageName="相続人" firstItemName="相続人の氏名" igonFlag={igonFlag}/>

                    <PageStep activeStep={0}/>

                    <PersonStep activeStep={2}/>

                    <MenuList pageName="相続人" />

                    <TextField
                        id="heiress_name"
                        name="heiress_name"
                        label="相続人の氏名"
                        style={{ margin: 8 }}
                        className={classes.required}
                        placeholder="相続人氏名をご入力ください。"
                        helperText={nameHelperText}
                        fullWidth
                        margin="normal"
                        inputProps={{
                            required: true,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handleName}
                        onChange={handleName}
                        error={nameValidate}
                        value={nameValue}
                    />
                    <TextField
                        id="heiress_birthday"
                        namee="heiress_birthday"
                        label="相続人の生年月日"
                        style={{ margin: 8 }}
                        className={classes.required}
                        helperText={birthHelperText}
                        fullWidth
                        type="date"
                        defalutValue="1985-01-01"
                        onChange={handleBirthday}
                        error={birthdayValidate}
                        value={birthdayValue}
                        inputProps={{
                            required: true,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <TextField
                        id="heiress_relationship"
                        name="heiress_relationship"
                        label="相続人の続柄"
                        style={{ margin: 8 }}
                        className={classes.required}
                        placeholder="相続人の続柄をご入力ください。"
                        helperText={relationshipHelperText}
                        fullWidth
                        margin="normal"
                        inputProps={{
                            required: true,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handleRelationship}
                        onChange={handleRelationship}
                        error={relationshipValidate}
                        value={relationshipValue}
                    />

                    {
                        (()=>{
                            if(heiress.length){
                                return (
                                    <TableContainer component={Paper} className={classes.list}>
                                        <Table size="small">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell className={classes.head}>相続人の氏名</TableCell>
                                                    <TableCell className={classes.head}>相続人の生年月日</TableCell>
                                                    <TableCell className={classes.head}>相続人の続柄</TableCell>
                                                    <TableCell className={classes.head}>&nbsp;</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                            {heiress.map((row, index) => {
                                                return (
                                                    <TableRow key={index} hover>
                                                        <TableCell>{row.name}</TableCell>
                                                        <TableCell>{row.birthday}</TableCell>
                                                        <TableCell>{row.relationship}</TableCell>
                                                        <TableCell>
                                                            <Button
                                                                variant="contained"
                                                                color="default"
                                                                onClick={(event) => { handleHeiressEdit(index, event) }}
                                                                startIcon={<EditIcon/>}
                                                                className={classes.operating}
                                                            >
                                                            編集
                                                            </Button>
                                                            <Button
                                                                variant="contained"
                                                                color="default"
                                                                onClick={(event) => { handleDialogOpen(index) }}
                                                                startIcon={<DeleteIcon/>}
                                                                className={classes.operating}
                                                            >
                                                            削除
                                                            </Button>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                );
                            }
                        })()
                    }

                    <Paper className={classes.explanation}>
                        <Typography>
                            相続人の情報をご入力ください。<br />
                            さらに相続人をご入力される場合は<Typography color="error" component="span">相続人を追加</Typography>をクリックして進んでください。<br />
                            全てご入力されたら財産目録の入力に進んでください。
                        </Typography>
                    </Paper>

                    <Box>
                        <Grid container className={classes.menu} spacing={2}>
                            <Grid item xs={6}>
                                <Button variant="contained" color="primary" fullWidth onClick={handleHeiress}>相続人を追加</Button>
                            </Grid>
                            <Grid item xs={6}>
                                <Button variant="contained" color="primary" fullWidth disabled={nextFlag} component={RouterLink} to="/money">財産目録の入力に移る</Button>
                            </Grid>
                            <Grid item xs={12}>
                                <Button variant="contained" color="default" fullWidth onClick={() => { history.goBack(); }}>前のページへ戻る</Button>
                            </Grid>
                        </Grid>
                    </Box>

                    <Dialog
                        open={open}
                        onClose={handleDialogClose}
                    >
                        <DialogTitle>{"削除確認"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                削除します。よろしいですか?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleDialogClose} color="dafalut">
                                いいえ
                            </Button>
                            <Button onClick={() => { handleHeiressDelete(deleteTargetIndex) }} color="secondary">
                                はい
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Grid>
                <Grid item xs={12} lg={6}>
                    <FlowTitle title="自筆証書遺言の作成の流れをご説明します。" />
                    <FlowItem image="img/icon_person.png" contents="①遺言者情報を登録<br>まず、遺言者の情報をご登録ください。" />
                    <FlowArrow/>
                    <FlowItem image="img/icon_memo.png" contents="②相続人の登録は「相続人の入力に移る」を<br>クリックし、相続人全ての方を入力ください。" />
                    <FlowCaution/>
                    <GuideHalf pageName="相続人"/>
                </Grid>
            </Grid>

        </Container>
    );
}

export default Heiress
